(function(){
  // Solo actuamos si existe el form principal del producto
  var form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  // --- helpers
  function addToCartThenGo(e){
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    var fd = new FormData(form);

    // Asegurar variant id
    if (!fd.get('id')) {
      var idInput = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
      if (idInput) fd.set('id', idInput.value);
    }
    // Asegurar quantity
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!fd.get('quantity')) fd.set('quantity', (qtyInput && qtyInput.value) ? qtyInput.value : '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(){ window.location.href = '/cart'; })
    .catch(function(){ window.location.href = '/cart'; });
  }

  function isBuyNowTarget(el){
    if (!el) return false;
    // Botón "Comprar ahora" unbranded o variantes de temas
    if (el.matches && (el.matches('.shopify-payment-button__button') ||
                       el.matches('.shopify-payment-button__button--unbranded') ||
                       el.matches('button[name="buy_now"]'))) return true;
    // Cualquier click dentro del contenedor del botón dinámico
    if (el.closest && (el.closest('.shopify-payment-button') ||
                       el.closest('[data-shopify="payment-button"]'))) return true;
    return false;
  }

  // 1) Delegación global: atrapa clicks aunque el botón se regenere
  document.addEventListener('click', function(e){
    if (isBuyNowTarget(e.target)) addToCartThenGo(e);
  }, true);

  // 2) Observa el contenedor y engancha onClick directos si cambia el DOM
  var container = document.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
  if (container && 'MutationObserver' in window) {
    var mo = new MutationObserver(function(){
      container.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded, button[name="buy_now"]').forEach(function(btn){
        btn.onclick = addToCartThenGo;
      });
    });
    mo.observe(container, { childList: true, subtree: true });
  }
})();
